import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createConstructionSiteEntityInfo } from 'record-it-time-common/entity/entities/ConstructionSite/createConstructionSiteEntityInfo';
import { ConstructionSite } from './constructionSiteTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export const constructionSiteEntityInfo =
  createConstructionSiteEntityInfo<ConstructionSite>({
    additionalFieldInfos:
      EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
  });
